type CheckRepositoryFileProps = {
  baseUrl: string;
  token: string;
  divisionName: string;
  teamName: string;
};

export const checkRepositoryFile = async ({
  baseUrl,
  token,
  divisionName,
  teamName,
}: CheckRepositoryFileProps) => {
  // Get Onboarded File
  const repositoryFileUrl = new URL(`${baseUrl}/repository-file`);
  repositoryFileUrl.search = new URLSearchParams({
    divisionName,
    teamName,
  }).toString();

  const response = await fetch(repositoryFileUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (response.status !== 404) {
      throw new Error(`Gitlab api error ${response.status}`, {
        cause: response.statusText,
      });
    }
  }
  const { file_path: filePath } = (await response.json()) as {
    file_path: string;
  };
  return { filePath };
};
